import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  CurrentYearAssumptions = 'CurrentYearAssumptions',
}

export const queryKeys = {
  currentYearAssumptions: (isConsumer: boolean, page?: string) => [
    QueryFeature.CurrentYearAssumptions,
    QueryKey.CurrentYearAssumptions,
    isConsumer,
    page,
  ],
};
